import { css } from 'styled-components';
import type { FontWeightName, HeadingLevel, TextSize } from '@makemydeal/dr-ui-bricks-types';
import { FONT_FAMILY, FONT_WEIGHT, HEADING_SIZE, HEADING_LINE_HEIGHT, TEXT_SIZE, TEXT_LINE_HEIGHT } from './constants';

/**
 * The `Text` component's font styles (family / size / line-height / weight) as a styled-components mixin
 */
export const textFontStyles = (size: TextSize, weight: FontWeightName) => css`
    font-family: ${({ theme }) => (theme as { uiBricks?: Record<string, string> }).uiBricks?.primaryFontFamily ?? FONT_FAMILY};
    font-size: ${TEXT_SIZE[size]};
    line-height: ${TEXT_LINE_HEIGHT[size]};
    font-weight: ${FONT_WEIGHT[weight]};
`;

/**
 * The `Heading` component's font styles as a mixin
 */
export const headingFontStyles = (level: HeadingLevel, weight: FontWeightName) => css`
    font-family: ${({ theme }) => {
        const ub = (theme as { uiBricks?: Record<string, string> }).uiBricks;
        return ub?.headlineFontFamily ?? ub?.primaryFontFamily ?? FONT_FAMILY;
    }};
    font-size: ${HEADING_SIZE[level]};
    line-height: ${HEADING_LINE_HEIGHT};
    font-weight: ${FONT_WEIGHT[weight]};
`;
